<app-shared-flock-overview [config]="config"></app-shared-flock-overview>
